import { Visit } from 'src/models/visit/_types';

import { VisitStatusTriggerButton } from './VisitStatusTriggerButton';

interface VisitStatusButtonProps {
  visit: Visit;
  setOpen: (open: boolean) => void;
  open: boolean;
  compact?: boolean;
}

export const VisitStatusButton = ({
  visit,
  setOpen,
  open,
  compact = false,
}: VisitStatusButtonProps) => (
  <VisitStatusTriggerButton
    visit={visit}
    open={open}
    compact={compact}
    onClick={() => setOpen(true)}
  />
);
